import { render, staticRenderFns } from "./CardCash.vue?vue&type=template&id=48b7c8e4&scoped=true"
import script from "./CardCash.vue?vue&type=script&lang=js"
export * from "./CardCash.vue?vue&type=script&lang=js"
import style0 from "./CardCash.vue?vue&type=style&index=0&id=48b7c8e4&prod&lanng=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b7c8e4",
  null
  
)

export default component.exports